import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter, Route, Switch } from 'react-router-dom';
import { MuiThemeProvider } from 'material-ui/styles';
import { theme } from '../../ui';
import { AppHeader, Loading } from './components/';
import { Dashboard, Inspection } from '../pages';
import { Profile, UserListPage } from '../user/components';
import ResetPasswordPage from '../user/components/ResetPasswordPage';
import * as authActions from '../auth/auth.actions';
import LoginForm from '../auth/components/LoginForm';
import SVGDefs from '../../icons/svgdefs';
import styled from 'styled-components';
import setAuthClasses from '../../utils/ui-utils';
//import { getCurrentUser } from '../user/user.selectors';

const MainContainer = styled.div`
  display: table-cell;
  height: 100vh;
  vertical-align: middle;
  margin: 0 auto;

  &.isAuthenticated {
    height: auto;
    display: block;
    vertical-align: inherit;
  }
`;

const Container = styled.div`
  padding-bottom: 1rem;
`;

class App extends Component {
  constructor(props) {
    super(props);

    const { loginUserToken } = props;
    const token = localStorage.getItem('wihuri-mia-token') || null;
    loginUserToken(token);
  }

  componentDidMount() {
    const { isAuthenticated } = this.props;
    const token = localStorage.getItem('wihuri-mia-token') || null;
    this.setAuthClasses(isAuthenticated, token === null);
  }

  componentWillReceiveProps(nextProps) {
    const { isAuthenticated, online } = nextProps;
    const token = localStorage.getItem('wihuri-mia-token') || null;
    this.setAuthClasses(isAuthenticated, online || token === null);
    this.checkUrlAfterLogin(nextProps, token, isAuthenticated, online);
  }

  checkUrlAfterLogin = (nextProps, token, isAuthenticated, online) => {
    const { setUrlAfterLogin, ulrAfterLogin, history } = nextProps;
    const canRender = isAuthenticated || (!online && token);
    const path = nextProps.location.pathname;
    // trying to view inspection without login > store url
    if (path.indexOf('/inspection/edit/') > -1 && !canRender && path !== ulrAfterLogin) {
      setUrlAfterLogin(path);
    } else if (canRender && ulrAfterLogin) {
      // logged in, move to inspection & clear url
      history.replace(ulrAfterLogin);
      setUrlAfterLogin(null);
    }
  };

  setAuthClasses = (isAuthenticated, online) => {
    setAuthClasses(isAuthenticated || !online ? true : false);
  };

  render() {
    const { isAuthenticated, isLoading, online, history } = this.props;
    const token = localStorage.getItem('wihuri-mia-token') || null;
    const canRender = isAuthenticated || (!online && token); //Dont render data if not authenticated or offline without token

    return (
      <MuiThemeProvider theme={theme}>
        <SVGDefs />
        <Switch>
          <Route
            path="/"
            render={props => {
              return (
                <MainContainer className={canRender ? 'isAuthenticated' : ''}>
                  {canRender && (
                    <AppHeader
                      history={history}
                      showMenu={props.location && props.location.pathname.indexOf('/inspection') !== 0}
                    />
                  )}
                  <Container>
                    {canRender ? (
                      <Switch>
                        <Route path="/inspection" component={Inspection} />
                        <Route path="/profile" exact render={routeProps => <Profile {...routeProps} backPath="/" />} />
                        <Route path="/users" render={routeProps => <UserListPage {...routeProps} backPath="/" />} />
                        <Route path="/profile_original" exact component={Profile} />
                        <Route path="/users_original" component={UserListPage} />
                        <Route path="/" component={Dashboard} />
                      </Switch>
                    ) : online && isLoading ? (
                      <Loading />
                    ) : (
                      <Switch>
                        <Route
                          exact
                          path="/setPassword/:emailToken"
                          render={() => {
                            return !canRender ? <ResetPasswordPage /> : <Redirect to="/" />;
                          }}
                        />
                        <Route exact path="/(resetPassword|unauthorized)?" component={LoginForm} />
                        <Redirect to="/" />
                      </Switch>
                    )}
                  </Container>
                </MainContainer>
              );
            }}
          />
        </Switch>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = state => {
  const { auth } = state;
  const { isAuthenticated, isLoading, role, ulrAfterLogin } = auth;
  const online = state.offline.online;

  return {
    auth,
    isAuthenticated,
    isLoading,
    role,
    online,
    ulrAfterLogin,
  };
};

const ConnectedApp = connect(mapStateToProps, Object.assign({}, authActions))(App);
export default withRouter(ConnectedApp);



// WEBPACK FOOTER //
// ./src/modules/core/App.js